import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PersonalLanding from './components/PersonalLanding';
import ConversationalExperience from './components/ConversationalExperience';
import Dashboard from './components/Dashboard';
import GuiaLoading from './components/GuiaLoading';
import AppRoadmap from './components/AppRoadmap';
import DiagnosticReport from './components/DiagnosticReport';
import WebStartChoice from './components/WebStartChoice';
import WebChat from './components/WebChat';
import LandingPage from './components/LandingPage';
import IniciaInfoPage from './components/IniciaInfoPage';
import IniciaFormPage from './components/IniciaFormPage';
import GraciasPage from './components/GraciasPage';
import InscripcionEnviadaPage from './components/InscripcionEnviadaPage';
import Entrevista from './components/Entrevista';
import PanelArea from './components/PanelArea';
import Privacidad from './components/Privacidad';
import CatalogoPagina from './components/CatalogoPagina';
import AgenciaOnboarding from './components/AgenciaOnboarding';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* La puerta es la conversación. Antes acá estaba la presentación de
              Antonela, que ahora vive en /antonela: la oferta cambia seguido y
              el chat es el que la tiene al día. */}
          <Route path="/" element={<ConversationalExperience />} />
          <Route path="/app" element={<ConversationalExperience />} />
          <Route path="/antonela" element={<PersonalLanding />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/catalogo" element={<CatalogoPagina />} />
          <Route path="/agencia-onboarding" element={<AgenciaOnboarding />} />
          <Route path="/loading" element={<GuiaLoading />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/web-start" element={<WebStartChoice />} />
          <Route path="/web-chat" element={<WebChat />} />
          <Route path="/roadmap" element={<AppRoadmap />} />
          <Route path="/diagnostico" element={<DiagnosticReport />} />
          <Route path="/legacy" element={<LandingPage />} />
          <Route path="/inicia" element={<IniciaInfoPage />} />
          <Route path="/inicia/formulario" element={<IniciaFormPage />} />
          <Route path="/inscripcion-enviada" element={<InscripcionEnviadaPage />} />
          <Route path="/gracias" element={<GraciasPage />} />
          {/* El entrevistador del pack empresa: un link por área de un cliente. */}
          <Route path="/entrevista/:area" element={<Entrevista />} />
          {/* La devolución del área, para An: se abre con la clave del panel. */}
          <Route path="/area/:clave" element={<PanelArea />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 